var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconStarColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCA28",
    d: "M12.5.595l4.167 7.738L25 9.523l-5.952 5.953 1.19 8.929-7.738-4.167-7.738 4.167 1.19-8.929L0 9.524l8.333-1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.095l4.167-4.762L12.5.595v12.5zM25 9.524l-12.5 3.571 6.548 2.381L25 9.524zm-4.762 14.88L12.5 13.096v7.143l7.738 4.167zM5.952 15.477l-1.19 8.929 7.738-11.31-6.548 2.381zM0 9.524l12.5 3.571-4.167-4.762L0 9.523z",
    fill: "#F9A825"
  }))));
}

export default SvgCommonIconStarColor;